import { Stack } from '@ui-components/neo.tax';
import { ReactElement } from 'react';

import type { ProviderUnion, SyncedProviders } from '@neo.tax/shared/types';

import { ProviderLogo } from '../provider-logo';

type SourcesContentProps = {
  linkedProviders: ProviderUnion[];
  placeholder: string;
  allProviders?: SyncedProviders;
};

export const SourcesContent = ({
  allProviders = {
    accountingProviders: [],
    payrollProviders: [],
    ticketingProviders: [],
  },
  linkedProviders,
  placeholder,
}: SourcesContentProps): ReactElement => {
  const providers = new Set(
    [...allProviders.accountingProviders, ...allProviders.payrollProviders, ...allProviders.ticketingProviders].map(
      (provider) => provider.providerName,
    ),
  );

  if (providers.size === 0) {
    return <>{placeholder}</>;
  }
  return (
    <Stack gap={4}>
      {[...providers.values()].map((providerName) => (
        <ProviderLogo
          key={providerName}
          provider={providerName}
          size={16}
          faded={!linkedProviders.includes(providerName)}
        />
      ))}
    </Stack>
  );
};
